import {Button, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import EventBulletIcon from '@icons/EventBulletIcon';
import Card from '../card/Card';
import IEvent from './IEvent';

interface IProps {
	events: IEvent[];
	seeAll?: boolean;
}

export default function EventBox({events, seeAll}: IProps) {
	const {t} = useTranslation();
	const date = new Date();
	return (
		<Card
			className="mx-4"
			title={t('nearest_event')}
			action={seeAll ? <Button component={Link} to="/calendar">{t('see_all')}</Button> : undefined}>
			<div className="px-2 py-2">
				{
					events.map((event, index) => {
						const today = (event.date.getDate() === date.getDate()
							&& event.date.getMonth() === date.getMonth()
							&& event.date.getFullYear() === date.getFullYear());
						return (<div key={index} className="flex flex-row items-center">
							<EventBulletIcon flip={t('_dir') === 'ltr'}/>
							<Typography sx={{
								color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200',
								height: t('_font') === 'urdu' ? '32px' : '',
								fontSize: (theme) => theme.typography.fontSize
							}} className="grow inline whitespace-nowrap overflow-hidden text-ellipsis">
								{event.title}
							</Typography>
							<Typography sx={{color: 'grey.400', fontSize: (theme) => theme.typography.fontSize - 4}}
							            className=" w-20 text-right rtl:text-left">
								{today ? t('today') : event.date.toLocaleDateString('fa-IR', {day: 'numeric', month: 'long'})}
							</Typography>
						</div>);
					})
				}
			</div>
		</Card>
	);
}
